import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-user-not-assigned-to-application-error-page',
  templateUrl: './user-not-assigned-to-application-error-page.component.html',
  styleUrls: ['./user-not-assigned-to-application-error-page.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UserNotAssignedToApplicationErrorPageComponent implements OnInit {

  public ngOnInit(): void {
    localStorage.clear();
  }
}
